import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/Rx';

import {
  Component, OnInit, Inject, Injectable, CUSTOM_ELEMENTS_SCHEMA, NgModule,
  Input, OnDestroy, Output, EventEmitter
} from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpErrorResponse, HttpHandler } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';

import { Credentials } from '../shared/models/credentials.interface';
import { } from 'jasmine';
import { finalize } from 'rxjs/operators';
import { NgForm } from '@angular/forms';
import { CommonSerivce } from '../shared/services/common.service';
import { DatePipe } from '@angular/common';
import { error } from 'protractor';
import { AuthService } from '../shared/services/auth.service'; // Import your AuthService


@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [CommonSerivce, DatePipe],
})


export class LoginComponent implements OnInit, OnDestroy {


  private subscription: Subscription;

  brandNew: boolean;
  errors: any[];
  success: string;  
  isRequesting: boolean = false;
  submitted: boolean = false;
  credentials: Credentials = { domainId: '', username: '', password: '' };
  changePwdCredentials: IChangePwdModel = {
    domainId: '', username: '', password: '',
    newPassword: '', confirmPassword: '',
    verifyCode: '', encPassword: '', encNewPassword: ''
  };
  //credentials: any = null;
  userInfo: IUserInfo = { domainId: '', userId: '' };
  invalidLogin: boolean = false;
  showChangePwdForm: boolean = false;

  LoginApiPath: string = "api/BcpJwtAuth/";
  EmailApiPath: string = "api/BcpEmailService/";


  constructor(private http: HttpClient, @Inject('BASE_URL') originUrl: string,
    //private userService: UserService,
    private router: Router,
    private activatedRoute: ActivatedRoute, 
    private authService: AuthService // Inject AuthService
    ) {
    this.setDefaultLogin();

  }

  ngOnInit() {

    // subscribe to router event

    this.subscription = this.activatedRoute.queryParams.subscribe(
      (param: any) => {
        //this.credentials.domainId = param['domainId']; 
        //this.credentials.username = param['username'];    
        //this.credentials.password = param['password'];         
      });


  }

  ngOnDestroy() {
    // prevent memory leak by unsubscribing
    this.subscription.unsubscribe();

  }

  changeFormMode() {
    if (this.showChangePwdForm) {
      this.errors = null;
      this.success = null;
      this.showChangePwdForm = false;
    } else {
      this.errors = null;
      this.success = null;
      this.showChangePwdForm = true;
    }
  }

  async login(form: NgForm) {
    var loginResult: any = {};
    let credentials = JSON.stringify(form.value);
    //console.log("credentials is " + credentials);
    this.errors = null;
    console.log("navigator.appName is  " + navigator.appName);
    console.log("navigator.userAgent is  " + navigator.userAgent);
    console.log("navigator.appVersion is  " + navigator.appVersion);
    console.log("navigator.appCodeName is  " + navigator.appCodeName);
    console.log("navigator.platform is  " + navigator.platform);
    console.log("navigator.language is  " + navigator.language);
    console.log("navigator.product is  " + navigator.product);
    console.log("navigator.vendor is  " + navigator.vendor);
    console.log("navigator.webdriver is  " + navigator.webdriver);
    console.log("navigator.mediaDevices is  " + navigator.mediaDevices);
    console.log("navigator.mediaDevices.getUserMedia is  " + navigator.mediaDevices.getUserMedia);
    console.log("navigator.vendor index  " + navigator.vendor.toUpperCase().indexOf("APPLE"));
    console.log("navigator.vendor index  " + navigator.vendor.toUpperCase().indexOf("GOOGLE"));
    this.http.post(this.LoginApiPath + "login", credentials, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    }).subscribe((result: any) => {
      loginResult = JSON.parse(result);
      sessionStorage.setItem("jwt", loginResult.auth_token);

      sessionStorage.setItem('auth_token', loginResult.auth_token);
      sessionStorage.setItem('auth_token_long', loginResult.auth_token_long);
      sessionStorage.setItem('validFor', JSON.stringify(loginResult.validFor));
      sessionStorage.setItem('tokenExpiration', JSON.stringify(loginResult.tokenExpiration));
      sessionStorage.setItem('longTokenExpiration', JSON.stringify(loginResult.longTokenExpiration));
      sessionStorage.setItem('sessionExpiration', JSON.stringify(loginResult.tokenExpiration));

      sessionStorage.setItem('currentDomain', JSON.stringify(loginResult.domainId));
      sessionStorage.setItem('currentUser', JSON.stringify(loginResult.loginId));
      sessionStorage.setItem('currentProcessRole', JSON.stringify(loginResult.processRole));
      sessionStorage.setItem('currentDataRole', JSON.stringify(loginResult.dataRole));
      sessionStorage.setItem('currentActionRole', JSON.stringify(loginResult.actionRole));
      sessionStorage.setItem('currentNoOfExpiredDoc', JSON.stringify(loginResult.numberOfExpiredDoc));
      sessionStorage.setItem('isLoggedIn', JSON.stringify("true"));
      sessionStorage.setItem('environment', JSON.stringify(loginResult.environment));
      sessionStorage.setItem('attachmentTarget', JSON.stringify(loginResult.attachmentTarget));

      //20230118 Enhancement Start - Add Config in appsetting for enable/ disable email functions - Jelly
      sessionStorage.setItem('enableCaseStatusEmail', JSON.stringify(loginResult.enableCaseStatusEmail));
      sessionStorage.setItem('enableCaseActivityEmail', JSON.stringify(loginResult.enableCaseActivityEmail));
      //20230118 Enhancement End

      sessionStorage.setItem('currentUserAccountType', JSON.stringify(loginResult.userAccountType));
      sessionStorage.setItem('currentCompanyCode', JSON.stringify(loginResult.companyCode));
      sessionStorage.setItem('currentContactId', JSON.stringify(loginResult.contactId));

      let tokenExpiration = JSON.parse(sessionStorage.getItem('tokenExpiration'));
      let longTokenExpiration = JSON.parse(sessionStorage.getItem('longTokenExpiration'));
      let utcDate = new Date();

      //console.log("Login Return Token is " + loginResult.auth_token);
      //console.log("Login Return Token Expiration " + sessionStorage.getItem('tokenExpiration'));
      this.invalidLogin = false;

      this.authService.login(loginResult.auth_token, loginResult.validFor); // Pass sessionExpiration

      this.router.navigate(["home"]);

    }, (error) => {
      let e1: any[];
      this.errors = JSON.parse(JSON.stringify(error.error))["login_result"];
      this.invalidLogin = true;
    });
  }

  sendVerifyCode() {
    this.userInfo.domainId = this.changePwdCredentials.domainId;
    this.userInfo.userId = this.changePwdCredentials.username;
    this.http.post(this.EmailApiPath + "SendVerifyCode", this.changePwdCredentials, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    }).subscribe((result: any) => {
      alert("Verify Code has been sent to your email address")
    }, (error) => {
      let e1: any[];
      alert("Please check your email address correct")
    });
    this.errors = null;
    this.success = null;
  }

  setDefaultLogin() {
    this.http.get(this.LoginApiPath + "getDefaultLogin", {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })
      .subscribe((result: any) => {
        this.credentials = JSON.parse(result);
        this.changePwdCredentials.domainId = this.credentials.domainId;
        this.changePwdCredentials.username = this.credentials.username;
        //console.log(result);
      }, (error) => {
      });
  }

  async changePwd(form: NgForm) {
    var changePwdResult: any = {};
    let changePwdCredentials = JSON.stringify(form.value);
    console.log("change credentials is " + changePwdCredentials);
    this.errors = null;
    this.success = null;
    let inputCheckOk: boolean;

    inputCheckOk = true;
   if (this.changePwdCredentials.newPassword !== this.changePwdCredentials.confirmPassword) {
      inputCheckOk = false;
      this.errors = ['New Password must equal to Confirm Password !'];
    }
    if (this.changePwdCredentials.newPassword.trim()==="") {
      inputCheckOk = false;
      this.errors = ['New Password cannot be blank !'];
    }
    if (this.changePwdCredentials.newPassword === this.changePwdCredentials.password) {
      inputCheckOk = false;
      this.errors = ['New Password cannot be same as Existing Password'];
    }
    if (this.changePwdCredentials.password.trim() === ""
      && this.changePwdCredentials.verifyCode.trim() === "") {
      inputCheckOk = true;
      this.errors = ['Please enter the Existing Password or the Verify Code !'];
    }
    if (inputCheckOk) {
      this.http.post(this.LoginApiPath + "changePwd", this.changePwdCredentials, {
        headers: new HttpHeaders({
          "Content-Type": "application/json"
        })
      }).subscribe((result: any) => {
        changePwdResult = JSON.parse(result);
        //console.log("change pwd result is " + changePwdResult.result);

        if (changePwdResult.result === "OK") {
          this.success = "Password Updated Succssfully!";
          this.changePwdCredentials.password = "";
          this.changePwdCredentials.newPassword = "";
          this.changePwdCredentials.confirmPassword = "";
          this.changePwdCredentials.verifyCode = "";
        }
        this.router.navigate(["login"]);

      }, (error) => {
        let e1: any[];
        this.errors = JSON.parse(JSON.stringify(error.error))["login_result"];
        this.invalidLogin = true;
      });
    } 
  }

  specialLink(linkTarget) {
    var linkString = "./assets/StaticPage/" + linkTarget + ".html";
    var win = window.open(linkString, '_blank');
    win.focus();

  }

}


interface IChangePwdModel {
  domainId?;
  username?;
  password?;
  newPassword?;
  confirmPassword?;
  verifyCode?;
  encPassword?;
  encNewPassword?;
}

interface IUserInfo {
  domainId?;
  userId?;
}




